<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'ml' }" :title="this.$t('management_page.public_access_prohibited_warning')")
    .form
      b-form-textarea(v-model="form.value" rows="5" max-rows="10")
    .modal-footer
      b-btn.btn-secondary(size="sm" @click="visible = false" pill) {{$t('cancel')}}
      b-btn(size="sm" variant="primary" @click="submit" pill) {{$t('management_page.accept_and_save')}}
</template>

<script>
import { CompanyFunctionAPI } from "@/api"
import _ from "lodash"
import Dialogs from "@/components/mixins/dialog/index.vue"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: "",
    },
  },
  components: {
    Dialogs,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
      if (newVal) {
        this.form.value = this.value
      }
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      form: {
        request_type: "public_place_alert",
        value: "",
      },
    }
  },
  methods: {
    submit() {
      const params = _.cloneDeep(this.form)
      CompanyFunctionAPI.put("", params).then(res => {
        const { status } = res
        if (status === 200) {
          this.$awn.success(String(this.$t('toasts_message.save_success')))
          this.$emit("update:value", this.form.value)
          this.$emit("update:show", false)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form {
  padding: 10px 30px;
}
</style>
